import moment from 'moment'
import _, { get, set } from 'lodash';
import { ajaxApi, ajaxApiGet,fileDownloadApiHui } from '@/server/index'
import { getCookie } from '@/public/utils'
import common from "@/public/common";


// var apiHost = 'http://192.168.10.67:8120/' || common.SapUrl
var apiHost =  common.SapUrl

const otherAdminName = getCookie('otheradminName') ? JSON.parse(getCookie('otheradminName')) : {}




export const getWaitDataApi = (params = {}) => {
    return ajaxApi({
        url: `${apiHost}invoice/invoice-match/query-account-page-list`,
        params: params,
    })
}

export const getMatchedDataApi = (params = {}) => {
    return ajaxApi({
        url: `${apiHost}invoice/invoice-match/query-match-page-list`,
        params: params,
    })
}

export const fetchInvoiceMatchingList = (params = {}) => {
    return ajaxApi({
        url: `${apiHost}invoice/invoice-match/query-match-page-list`,
        params
    }, 'data')
}
// 匹配单状态变更
export const updateMatchingStatus = (params = {}) => {
    return ajaxApi({
        url: `${apiHost}invoice/invoice-match/update-status`,
        params: {
            ...params,
            auditer: otherAdminName.RealName,
            auditer_py: otherAdminName.UserName,
            auditer_id: otherAdminName.UserID,
        }
    }, 'data')
}

// 匹配单状态变更
export const  setTemp= (params = {}) => {
    return ajaxApi({
        url: `${apiHost}invoice/cache-and-return-selected-zd`,
        params
    }, 'data')
}

// 导出
export const invoiceMatchingExport = (params) => {
    return fileDownloadApiHui({
        url: `${apiHost}invoice/invoice-match/query-match-page-list/export`,
        param: params,
        filename: '发票匹配列表_' + moment().format('YYYYMMDDHHmmss') + '.xlsx'
    })
}


// WEBPACK FOOTER //
// ./src/pages/billVerification/match/list/api.js